/**
 * iOS-safe page scroll lock (menu drawer + cart sidebar).
 * DOM state is the source of truth (overflow-hidden-*, menu-open, wod-sidebar-lock).
 */
(function () {
  let locked = false;
  let savedY = 0;
  let touchBound = false;
  let syncing = false;

  const SCROLLABLE =
    '.menu-drawer, .menu-drawer__inner-container, .menu-drawer__navigation-container, .menu-drawer__navigation, .menu-drawer__submenu, .wod-sidebar, .wod-sidebar__body, .cart-drawer, .drawer__inner, .drawer__contents, .wod-sheet-modal__body, .announcement-bar-modal__body';

  function isInsideScrollable(target) {
    return Boolean(target && target.closest && target.closest(SCROLLABLE));
  }

  function onTouchMove(event) {
    if (!locked) return;
    if (event.touches.length > 1) return;
    if (isInsideScrollable(event.target)) return;
    event.preventDefault();
  }

  function bindTouchBlock() {
    if (touchBound) return;
    touchBound = true;
    document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
  }

  function unbindTouchBlock() {
    if (!touchBound) return;
    touchBound = false;
    document.removeEventListener('touchmove', onTouchMove, { capture: true });
  }

  function setLocked(on) {
    if (on === locked) return;
    if (on) {
      savedY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('wod-scroll-lock');
      document.body.style.top = `-${savedY}px`;
      bindTouchBlock();
      locked = true;
    } else {
      document.documentElement.classList.remove('wod-scroll-lock');
      document.body.style.top = '';
      unbindTouchBlock();
      locked = false;
      window.scrollTo(0, savedY);
    }
  }

  function menuIsOpen() {
    const body = document.body;
    if (!body) return false;
    if (
      body.classList.contains('overflow-hidden-mobile') ||
      body.classList.contains('overflow-hidden-tablet') ||
      body.classList.contains('overflow-hidden-desktop') ||
      body.classList.contains('overflow-hidden')
    ) {
      return true;
    }
    if (document.querySelector('.section-header.menu-open')) return true;
    if (document.querySelector('header-drawer > details[open], header-drawer details.menu-opening')) return true;
    return false;
  }

  function cartIsOpen() {
    return Boolean(
      document.documentElement.classList.contains('wod-sidebar-lock') ||
        document.querySelector('wod-sidebar-drawer.is-open, .wod-sidebar.is-open, cart-drawer.active')
    );
  }

  function sheetIsOpen() {
    return Boolean(
      document.querySelector(
        'modal-dialog.wod-sheet-modal[open], modal-dialog.announcement-bar-modal[open], modal-dialog[open].wod-sheet-modal, modal-dialog[open].announcement-bar-modal'
      ) || document.querySelector('#WodCartUploadLightbox.is-open')
    );
  }

  function syncFromDom() {
    if (syncing) return;
    syncing = true;
    try {
      setLocked(menuIsOpen() || cartIsOpen() || sheetIsOpen());
    } finally {
      syncing = false;
    }
  }

  // Public API kept for cart-drawer / sidebars (they toggle classes then call these).
  window.WodScrollLock = {
    lock: syncFromDom,
    unlock: syncFromDom,
    sync: syncFromDom,
  };

  function patchMenuDrawer(tagName) {
    const Ctor = customElements.get(tagName);
    if (!Ctor || Ctor.prototype.__wodScrollPatched) return;
    const proto = Ctor.prototype;
    const open = proto.openMenuDrawer;
    const close = proto.closeMenuDrawer;
    if (typeof open !== 'function' || typeof close !== 'function') return;

    proto.openMenuDrawer = function (...args) {
      open.apply(this, args);
      syncFromDom();
    };

    if (tagName === 'menu-drawer') {
      proto.closeMenuDrawer = function (...args) {
        close.apply(this, args);
        requestAnimationFrame(syncFromDom);
      };
    }

    proto.__wodScrollPatched = true;
  }

  function patchWhenReady() {
    patchMenuDrawer('menu-drawer');
    patchMenuDrawer('header-drawer');
  }

  function bootObserver() {
    const obs = new MutationObserver(() => syncFromDom());
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    obs.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'open'],
      subtree: true,
    });

    const headerSection = document.querySelector('#shopify-section-header, .section-header, header-drawer');
    if (headerSection) {
      obs.observe(headerSection, {
        attributes: true,
        attributeFilter: ['class', 'open'],
        subtree: true,
      });
    }

    document.addEventListener(
      'toggle',
      (e) => {
        if (e.target?.closest?.('header-drawer, menu-drawer')) {
          requestAnimationFrame(syncFromDom);
        }
      },
      true
    );

    syncFromDom();
  }

  function boot() {
    if (customElements.get('header-drawer') || customElements.get('menu-drawer')) {
      patchWhenReady();
    } else {
      customElements.whenDefined('menu-drawer').then(patchWhenReady);
      customElements.whenDefined('header-drawer').then(patchWhenReady);
    }
    bootObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
